import { useCallback, useContext, useEffect, useState } from "react";
import "./WrapListPage.scss";
import * as orderService from "../../Services/Http/OrderService";
import { OrderList } from "../../Models/OrderList";
import { ApiError } from "../../Models/ApiError";
import { ChangeStatusRequest } from "../../Models/ChangeStatusRequest";
import { TransHeaderResponse } from "../../Models/TransHeaderResponse";
import { Order } from "../../Models/Order";
import OrderListComponent from "../../Components/OrderListComponent/OrderListComponent";
import { dataContext } from "../../Context/contextProvider";

const WrapListPage = () => {
  const [orders, setOrders] = useState<Order[]>([]);
  const dataStore = useContext(dataContext);

  const bindGrid = useCallback(() => {
    orderService
      .getExistingOrdersForWrapAPI(dataStore.serverUrl || "", dataStore.dbKey || "")
      .then((resp: OrderList) => {
        if (resp) {
          setOrders([...resp.result!]);
        } else {
          setOrders([]);
        }
      })
      .catch((err: ApiError) => {
        //toast.error(err.message); //error already handled in error handler
      });
  }, [dataStore.dbKey, dataStore.serverUrl]);

  useEffect(() => {
    bindGrid();
  }, [bindGrid]);

  const handleSetModalResult = (changeStatusRequest: ChangeStatusRequest): Promise<TransHeaderResponse> => {
    return new Promise<TransHeaderResponse>((resolve, reject) => {
      orderService
        .setOrderWrapStatusAPI(changeStatusRequest, dataStore.serverUrl || "", dataStore.dbKey || "")
        .then((resp: TransHeaderResponse) => {
          bindGrid();
          resolve(resp);
        })
        .catch((err: ApiError) => {
          bindGrid();
          reject(err);
        });
    });
  };
  return <OrderListComponent orderArr={orders} modalTitle="Has the delivery been wrapped?" onSetModalResult={handleSetModalResult} />;
};

export default WrapListPage;
